import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";

export const RoundOff: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  
  return (
    <Grid container padding={2}>
      <Grid item xs={12}>
        <Typography>Change Round off (Adjusted) Amount of Receipt</Typography>
        <Divider sx={{ mt: 1, mb: 2 }} /> {/* Divider with spacing around it */}
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography>Round Off</Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <WSTextField
          label={""}
          {...register("roundoff")}
          id="roundoff"
          name="roundoff"
          control={control}
          rules={{ required: false }}
        />
      </Grid>
    </Grid>
  );
});
